/**
 * Claims Payment Status — Payment Advice Optional.
 * A claim (or payment batch) marked Paid without its payment advice carries
 * `payment_advice_pending` from the API and reads "Paid — Payment Advice
 * Pending" until the advice is uploaded for its batch.
 */
export const PAID_ADVICE_PENDING_LABEL = 'Paid — Payment Advice Pending';

const truthy = (v) => v === true || v === 1 || v === '1' || v === 'true';

/** For a claim row (claims_status 3) or a batch object (always Paid). */
export function isPaymentAdvicePending(record) {
  if (!record || !truthy(record.payment_advice_pending)) return false;
  return record.claims_status == null || Number(record.claims_status) === 3;
}

/** "Paid" or "Paid — Payment Advice Pending". */
export function paidLabel(record, base = 'Paid') {
  return isPaymentAdvicePending(record) ? PAID_ADVICE_PENDING_LABEL : base;
}
